import { Box, Divider, Typography } from "@mui/material"

export function TaskReadOnlyHtmlSection({ title, html }) {
    if (!html) return null

    return (
        <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                {title}
            </Typography>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ "& p": { mt: 0 }, "& :last-child": { mb: 0 } }} dangerouslySetInnerHTML={{ __html: html }} />
        </Box>
    )
}
